import React from 'react';
import PropTypes from 'prop-types';
import RestrictedEmails from '../invites/restrictedEmails';
import DuplicateEmails from '../invites/duplicateEmails';
import InviteSuggestion from '../invites/inviteSuggestion';
import CommentSuggestion from '../comments/commentSuggestion';
import Cropper from '../../containers/cropperContainer';

const Modal = props => (
  <div className="modal">
    <div className="oc-modal">
      {props.modalOnDisplay === 'comment-suggestion' && (
        <CommentSuggestion
          translations={props.translations}
          color={props.color}
          displayModal={props.displayModal}
        />
      )}
      {props.modalOnDisplay === 'invite-suggestion' && (
        <InviteSuggestion
          translations={props.translations}
          color={props.color}
          displayModal={props.displayModal}
          invites={props.invites}
        />
      )}
      {props.modalOnDisplay === 'duplicates' && (
        <DuplicateEmails
          translations={props.translations}
          color={props.color}
          duplicateEmails={props.duplicateEmails}
          removeDuplicates={props.removeDuplicates}
          resendDuplicates={props.resendDuplicates}
          restrictedEmails={props.restrictedEmails}
          error={props.error}
        />
      )}
      {props.modalOnDisplay === 'restricted' && (
        <RestrictedEmails
          translations={props.translations}
          color={props.color}
          duplicateEmails={props.duplicateEmails}
          restrictedEmails={props.restrictedEmails}
          displayModal={props.displayModal}
        />
      )}
      {props.modalOnDisplay === 'cropper-0' && (
        <Cropper uploadedImage={props.uploadedImages[0]} index={0} />
      )}
      {props.modalOnDisplay === 'cropper-1' && (
        <Cropper uploadedImage={props.uploadedImages[1]} index={1} />
      )}
      {props.modalOnDisplay === 'cropper-2' && (
        <Cropper uploadedImage={props.uploadedImages[2]} index={2} />
      )}
    </div>
  </div>
);

Modal.propTypes = {
  translations: PropTypes.objectOf(PropTypes.string).isRequired,
  color: PropTypes.string.isRequired,
  modalOnDisplay: PropTypes.string.isRequired,
  invites: PropTypes.shape({}),
  displayModal: PropTypes.func,
  removeDuplicates: PropTypes.func,
  resendDuplicates: PropTypes.func,
  restrictedEmails: PropTypes.array,
  duplicateEmails: PropTypes.shape({
    emails: PropTypes.array,
    resendUrl: PropTypes.string,
    delayDisplayAlert: PropTypes.bool,
  }),
  uploadedImages: PropTypes.array,
  error: PropTypes.string,
};

Modal.defaultProps = {
  invites: {},
  displayModal: () => {},
  removeDuplicates: () => {},
  resendDuplicates: () => {},
  restrictedEmails: [],
  duplicateEmails: {
    emails: [],
    resendUrl: '',
    delayDisplayAlert: false,
  },
  uploadedImages: [],
  error: '',
};

export default Modal;
